import missionClaim from '@/api/mission/mission-claim'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  unclaimedMissions: []
}

export const mutations = {
  ...baseMutations,
  SET_UNCLAIMED_MISSIONS(state, data) {
    state.unclaimedMissions = data
  }
}

export const getters = {}

export const actions = {
  fetch(context, attributes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: { search: context.state.search }
      },
      attributes
    )
    return missionClaim.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  async getUnclaimedMissions({ commit }) {
    const response = await missionClaim.getUnclaimedMissions()
    commit('SET_UNCLAIMED_MISSIONS', response)
  },

  async getMissionDetail(_, missionId) {
    return await missionClaim.getMissionDetail(missionId)
  },

  async claim(_, { missionId, data }) {
    return await missionClaim.claim(missionId, data)
  },

  update(_, { missionId, data }) {
    return missionClaim.update(missionId, data)
  },

  destroy(_, missionId) {
    return missionClaim.destroy(missionId)
  }
}
